module.exports = __webpack_public_path__ + "img/cross.28377399.svg";